var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercardCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 20,
  fill: "none",
  viewBox: "0 0 35 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 23,
  x: 0.5,
  y: 0.5,
  fill: "#fff",
  stroke: "#D9D9D9",
  rx: 3.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ED0006",
  fillRule: "evenodd",
  d: "M17.75 17.157a6.75 6.75 0 0 1-4.426 1.649c-3.769 0-6.824-3.09-6.824-6.903S9.555 5 13.324 5a6.75 6.75 0 0 1 4.426 1.649A6.75 6.75 0 0 1 22.176 5C25.945 5 29 8.09 29 11.903s-3.055 6.903-6.824 6.903a6.75 6.75 0 0 1-4.426-1.65",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9A000",
  fillRule: "evenodd",
  d: "M17.75 17.157a6.92 6.92 0 0 0 2.398-5.254 6.92 6.92 0 0 0-2.398-5.254A6.75 6.75 0 0 1 22.176 5C25.945 5 29 8.09 29 11.903s-3.055 6.903-6.824 6.903a6.75 6.75 0 0 1-4.426-1.65",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5E00",
  fillRule: "evenodd",
  d: "M17.75 6.65a6.92 6.92 0 0 1 2.398 5.253 6.92 6.92 0 0 1-2.398 5.254 6.92 6.92 0 0 1-2.398-5.254 6.92 6.92 0 0 1 2.398-5.254",
  clipRule: "evenodd"
})));
export default SvgMastercardCard;